import useTable from '../../../hooks/useTable';
import { Table } from '../../Table';
import { TableComponentProps } from '../types';

const columnLables = {
  exchanged_traded_derivatives_exposure: {
    name: 'Exchange traded derivatives exposure amount',
    order: 287
  },
  otc_derivatives_amount: {
    name: 'OTC derivatives exposure amount',
    order: 288
  },
  short_position_borrowed_securities: {
    name: 'Short position borrowed securities value',
    order: 289
  }
};

export function DerivativesExposure({
  funds,
  onChangeFund,
  currentDataKey,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) {
  const {
    rows: rows,
    columns: columns,
    onChange: onChange
  } = useTable({
    data: funds[currentDataKey]?.fund_data?.DERIVATIVE_EXPOSURE,
    onChangeFund,
    schema: schema.DERIVATIVE_EXPOSURE,
    isStaticTemplate,
    requiredFields: funds[currentDataKey]?.required_tables?.DERIVATIVE_EXPOSURE?.field_names || [],
    columnLables,
    tableName: 'DERIVATIVE_EXPOSURE',
    isMultiFunds,
    funds
  });

  return (
    <Table
      id="reporttables-derivatives-exposure-table"
      stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 2 : null}
      handleChanges={onChange}
      columns={columns}
      rows={rows}
    />
  );
}
